import { ProdStateScreen } from '@/components/admin/prod/prod-state-screen';
import { createFileRoute } from '@tanstack/react-router';

/**
 * « État de la prod » (docs/specs/vitrine.md §9.3, issue #192, lot F): what the dev has ahead of the
 * prod, and what the prod says of each line. Opened from the banner of the atelier; it has no entry
 * in the rail, the maquette has none either.
 *
 * Only the atelier has it: on the vitrine the shell sends `/admin/prod` back to the home of the admin
 * (`vitrineRedirect`). The screen itself is `components/admin/prod/prod-state-screen.tsx`, a component
 * so that it is tested (the routes are out of the coverage).
 */
export const Route = createFileRoute('/admin/prod')({
  component: ProdStateScreen,
});
